import { siteContent } from "../content";
import WarningIcon from "./icons/warning.icon";
const errorMessage = siteContent.errorMessage;

const Error = () => (
  <div className="bg-red-100 border-2 cursor-default border-red-400 text-red-600 p-3 rounded-lg shadow-lg shadow-slate-300 mb-5 font-semibold">
    <WarningIcon className="fill-red-500 text-red-50 w-8 h-8 inline-block mr-2 align-middle" />
    {errorMessage.content}
  </div>
);

export default Error;
